import { gql } from 'graphql-request'

export const LINK_WITH_LINE = gql`
  mutation LinkWithLine($linkWithLineInput: LinkWithLineInput!) {
    linkWithLine(linkWithLineInput: $linkWithLineInput) {
      message
    }
  }
`
